const cm = {
    checkPhone(val){
        if(!(/^1[123456789]{1}\d{9}$/.test(val))){
            return false;
        }else{
            return true;
        }
    }
}
export default cm;